import React from 'react';

import { Box, Flex, xcss } from '@atlaskit/primitives';

const bylineStyles = xcss({
	height: '32px', // this value MUST match the fixed height of the LivePagesBylineStyledMainDiv in PresentationalComponents.tsx
});

const circleStyles = xcss({
	backgroundColor: 'color.skeleton',
	width: '20px',
	height: '20px',
	borderRadius: '50%',
	margin: 'space.025',
});

const lineStyles = xcss({
	backgroundColor: 'color.skeleton',
	width: '100px',
	height: '16px',
	borderRadius: '2px',
});

export const LivePagesByLinePlaceholderComponent = () => {
	return (
		<Flex alignItems="center" gap="space.050" xcss={bylineStyles}>
			<Box xcss={circleStyles} />
			<Box xcss={lineStyles} />
		</Flex>
	);
};
